import { render, staticRenderFns } from "./ViewCustomerPage.vue?vue&type=template&id=1a13a8be"
import script from "./ViewCustomerPage.vue?vue&type=script&lang=js"
export * from "./ViewCustomerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports